import { useContext } from 'react';

import { UserContext } from '@/auth/user-context-provider';
import { IframeContainer } from '@/components/iframe-container';
import { NoPermissionsPage } from '@/components/no-permissions-page';

export function HsmAdminEmbed() {
  const { isAdmin } = useContext(UserContext);

  if (!isAdmin) {
    return <NoPermissionsPage />;
  }
  return <IframeContainer />;
}
